import React, {Component} from 'react';

class AppLoader extends Component {

     constructor(props) {
        super(props);
        this.state = {countNumber : props.endNumber };
    }

    componentDidMount() {
       
    }


    render () {
        return (
             <div className="app-loader">

             	<div className="app-loader__center">
             		<img className="app-loader__logo" src="https://rascalsthemes.com/images/logo.svg" alt="Rascals Themes" />
             	</div>

             	
             	<div className="app-loader__progress progress">
        			<div className="progress__bar"></div>
    			</div>

             </div>
        );
    }
}

export default AppLoader;


// WEBPACK FOOTER //
// ./src/components/AppLoader/AppLoader.js